// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__bH_h0","placeholder":"Video_placeholder__cxy20","hide":"Video_hide__JlTsE"};